import React, { ReactNode, useEffect, useState } from "react"
import { Modal, Alert, FormControl, Button } from "react-bootstrap";
import { PlusLg, Save, XLg } from "react-bootstrap-icons";
import { useAuth } from "../Auth";
export const SelectorLista: React.FC<{ current: any[], lista: any[], onSelect: Function, children: ReactNode }> = ({ current, lista, onSelect, children }) => {
    let auth = useAuth();

    const [mostrar, setMostrar] = useState(false)
    const [filtro, setFiltro] = useState("")
    const [elementos, setElementos] = useState<any[]>([])

    useEffect(() => {
        if (auth.user && mostrar) {
            setElementos(current)
            setFiltro("")
        }
        // eslint-disable-next-line
    }, [auth.user, mostrar])

    var filtradas = lista.filter((elemento: any) => {
        var show = false;

        if (filtro === "") {
            show = true
        }

        if (elementos.filter((e: any) => e.id === elemento.id).length > 0) {
            show = false;
        }
        return show
    });

    return <>
        <span onClick={() => setMostrar(!mostrar)}>{children}</span>
        <Modal show={mostrar} backdrop="static" onHide={() => setMostrar(false)} centered fullscreen={"sm-down"}>
            <Modal.Header closeButton><b>Elementos agregados</b></Modal.Header>
            <Modal.Body className="pt-0">
                {elementos.length === 0 && <Alert variant="info" className="py-0 w-auto d-inline-block">Aún no se han agregado elementos</Alert>}
                {elementos.length > 0 && elementos.map((item: any) => {
                    return <Button key={item.id} onClick={() => setElementos(elementos.filter((e:any)=>e.id!==item.id))} size="sm" variant={item.bg ? item.bg : "outline-dark"} className="me-2">
                        {item.text} <PlusLg />
                    </Button>
                })}

                <hr />

                <h6 className="mt-2">Elementos disponibles</h6>
                <FormControl placeholder="Filtrar..." value={filtro} onChange={(ev) => setFiltro(ev.target.value)} className="mb-2 d-none" size="sm" />
                <div>
                    {filtradas.length === 0 && <Alert variant="info" className="py-0 w-auto d-inline-block">Sin elementos disponibles</Alert>}
                    {filtradas.length > 0 && filtradas.map((item: any) => {
                        return <Button key={item.id} onClick={() => setElementos([...elementos, item])} size="sm" variant={item.bg ? item.bg : "outline-dark"} className="me-2">
                            {item.text} <PlusLg />
                        </Button>
                    })}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button size="sm" variant="dark" onClick={() => { onSelect(elementos); setMostrar(false) }}><Save /> Guardar</Button>
                <Button size="sm" variant="danger" onClick={() => setMostrar(false)}><XLg /> Cancelar</Button>
            </Modal.Footer>
        </Modal>
    </>
}